import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { ReactComponent as DistroIcon } from "shared/assets/images/icon-distribution-side-menu.svg";
import { ReactComponent as DiagnosticoIcon } from "shared/assets/images/icon-assessment-side-menu.svg";
import { ReactComponent as RecomendacaoIcon } from "shared/assets/images/icon-connections-side-menu.svg";
import { ReactComponent as IconAdiantamentos } from "shared/assets/images/icon-advance-side-menu.svg";
import { ReactComponent as HomeIcon } from "shared/assets/images/icon-home-side-menu.svg";
import { ReactComponent as QuincyIcon } from "shared/assets/images/icon-quincy-side-menu.svg";
import { ReactComponent as IconMetas } from "shared/assets/images/icon-goals-side-menu.svg";
import { ReactComponent as PitchinIcon } from "shared/assets/images/icon-pitching-side-menu.svg";
import { ReactComponent as ReleasesScheduleIcon } from "shared/assets/images/icon-releases-side-menu.svg";
import { ReactComponent as IconStrmClass } from "shared/assets/images/icon-class-side-menu.svg";
import { ReactComponent as IconMenu } from "shared/assets/images/menu.svg";
import { ReactComponent as LevelMenu } from "shared/assets/images/icon-stage-side-menu.svg";
import { ReactComponent as PromotionIcon } from "shared/assets/images/icon-promotion-side-menu.svg";
import { ReactComponent as TouringIcon } from "shared/assets/images/icon-touring.svg";
import { ReactComponent as AIAgentsIcon } from "shared/assets/images/icon-ai-agents.svg";
import { ReactComponent as HumanTeamIcon } from "shared/assets/images/icon-contact-side-menu.svg";
import { isEnableFullDiagnostic } from "shared/helpers/full-diagnostic-helpers";
import BadgeNew from "../badge-new/BadgeNew";
import { useFlags } from "launchdarkly-react-client-sdk";
import { dataLayerClickedEvent } from "event-tracker/gtm-events";
import { MenuButtonClickEventName } from "event-tracker/button-click-event-name";
import { ArtistState } from "explorer/reducers/artistas";
import { UserState } from "explorer/reducers/users";
import { DistributionStatusEnum } from "shared/enums/DistributionStatusEnum";
import MenuTag from "../subscription/MenuTag";
import { allowedTouringArtist } from "shared/helpers/touring-permissions";
import { LabelServicesCalendlyLink } from "shared/helpers/calendly-contact";
interface ContentMenuProps {
  onCloseMenu?: () => void;
  fullScreen?: boolean;
}

const ContentMenu: React.FC<ContentMenuProps> = ({
  onCloseMenu = () => {},
  fullScreen,
}) => {
  const { t } = useTranslation();
  const { loggedUser } = useSelector((state: UserState) => state.users);
  const { userArtist } = useSelector((state: ArtistState) => state.artists);
  const acessoReleasePlanning = loggedUser?.isReleasePlanningEnable;
  const allowLabelServices = (userArtist?.stage || 0) >= 7;

  const { showHome } = useFlags();
  const showTouring = allowedTouringArtist(userArtist?.country || "");

  const handleShineMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const item = (e.target as HTMLElement).closest<HTMLElement>(
      ".menu-grid-item",
    );
    e.currentTarget
      .querySelectorAll<HTMLElement>(".menu-grid-item")
      .forEach((el) => {
        if (el !== item) el.style.setProperty("--size", "0px");
      });
    if (!item) return;
    const rect = item.getBoundingClientRect();
    item.style.setProperty("--x", `${e.clientX - rect.left}px`);
    item.style.setProperty("--y", `${e.clientY - rect.top}px`);
    item.style.setProperty("--size", "200px");
    item.style.setProperty("--shineColor", "rgba(255, 255, 255, 0.12)");
  };

  const handleShineLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget
      .querySelectorAll<HTMLElement>(".menu-grid-item")
      .forEach((el) => {
        el.style.setProperty("--size", "0px");
        el.style.setProperty("--shineColor", "rgba(255, 255, 255, 0)");
      });
  };

  const onClickMenuItem = (
    eventName?: keyof typeof MenuButtonClickEventName,
  ) => {
    if (eventName && MenuButtonClickEventName[eventName]) {
      dataLayerClickedEvent(MenuButtonClickEventName[eventName] as any, {
        businessContext: "MENU",
        platformContext: "S4A",
      });
      onCloseMenu();
    }
  };

  return (
    <div
      className={`scroll-style mobile-menu-overlay${
        fullScreen ? " full-screen-menu" : ""
      }`}
    >
      <div className="full-menu-content">
        <div className="full-menu-section">
          <div className="section-title body-small">
            {t("components.MenuLateral.essentials")}
          </div>
          <div
            className="menu-grid"
            onMouseMove={handleShineMove}
            onMouseLeave={handleShineLeave}
          >
            <NavLink
              exact
              to={showHome ? "/" : "/estagio"}
              isActive={(_, location) =>
                showHome
                  ? location.pathname === "/" || location.pathname === "/home"
                  : location.pathname === "/estagio"
              }
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.HOME)}
            >
              <HomeIcon className="icon" />
              <span className="label">Home</span>
            </NavLink>
            <NavLink
              to="/promotion"
              className="menu-grid-item body-regular"
              onClick={() =>
                onClickMenuItem(MenuButtonClickEventName.SONGTOOLS_MENU_CTA)
              }
              style={{ position: "relative" }}
            >
              {/* <BadgeNew
                text={t("pages.Home.new")}
                style={{ position: "absolute", top: 10, right: 6 }}
              /> */}
              <PromotionIcon className="icon" />
              <span className="label">
                {t("components.MenuLateral.promotion")}
              </span>
            </NavLink>
            {showHome && (
              <NavLink
                to="/estagio"
                className="menu-grid-item body-regular"
                onClick={() => onClickMenuItem(MenuButtonClickEventName.LEVEL)}
              >
                <LevelMenu className="icon" />
                <span className="label">
                  {t("components.MenuLateral.estagio")}
                </span>
              </NavLink>
            )}
            {isEnableFullDiagnostic(userArtist) && (
              <NavLink
                to="/diagnosticos"
                className="menu-grid-item body-regular"
                onClick={() =>
                  onClickMenuItem(MenuButtonClickEventName.ASSESSMENT)
                }
              >
                <DiagnosticoIcon className="icon" />
                <span className="label">
                  {t("components.MenuLateral.diagnostico")}
                </span>
              </NavLink>
            )}

            <NavLink
              to="/adiantamentos"
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.ADVANCES)}
            >
              <IconAdiantamentos className="icon" />
              <span className="label">Advances</span>
            </NavLink>
          </div>
        </div>
        <div className="full-menu-section">
          <div className="section-title body-small">
            {t("components.MenuLateral.acceleration")}
          </div>
          <div
            className="menu-grid"
            onMouseMove={handleShineMove}
            onMouseLeave={handleShineLeave}
          >
            <NavLink
              to="/quincy"
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.QUINCY)}
            >
              <MenuTag variant="pro" />
              <QuincyIcon className="icon" />
              <span className="label">Quincy</span>
            </NavLink>

            <NavLink
              to="/conexoes"
              className="menu-grid-item body-regular"
              onClick={() =>
                onClickMenuItem(MenuButtonClickEventName.CONNECTIONS)
              }
            >
              <MenuTag variant="pro" />
              <RecomendacaoIcon className="icon" />
              <span className="label">
                {t("components.MenuLateral.recomendacoes")}
              </span>
            </NavLink>

            <NavLink
              to="/metas"
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.GOALS)}
            >
              <MenuTag variant="pro" />
              <IconMetas className="icon" />
              <span className="label">{t("components.MenuLateral.goals")}</span>
            </NavLink>

            <NavLink
              to="/strm-class"
              className="menu-grid-item body-regular"
              onClick={() =>
                onClickMenuItem(MenuButtonClickEventName.STRM_CLASS)
              }
            >
              <MenuTag variant="pro" />
              <IconStrmClass className="icon" />
              <span className="label">Strm Class</span>
            </NavLink>

            {showTouring && (
              <NavLink
                to="/touring"
                className="menu-grid-item body-regular"
                onClick={() =>
                  onClickMenuItem(MenuButtonClickEventName.TOURING)
                }
                style={{ position: "relative" }}
              >
                <BadgeNew
                  text={t("pages.Home.new")}
                  style={{ position: "absolute", top: 10, right: 6 }}
                />
                <TouringIcon className="icon" />
                <span className="label">
                  {t("components.MenuLateral.touring")}
                </span>
              </NavLink>
            )}
          </div>
        </div>
        <div className="full-menu-section">
          <div className="section-title body-small">
            {t("components.MenuLateral.smartDistribution")}
          </div>
          <div
            className="menu-grid"
            onMouseMove={handleShineMove}
            onMouseLeave={handleShineLeave}
          >
            {(userArtist?.distribution?.available ||
              userArtist?.distribution?.status ===
                DistributionStatusEnum.Signed ||
              userArtist?.distribution?.status ===
                DistributionStatusEnum.Pending ||
              loggedUser?.revelatorPartnerId) && ( //essa condição é pq a distro fica available false se estiver como tentativa de fraude
              <NavLink
                to="/distribuicao"
                className="menu-grid-item body-regular"
                onClick={() =>
                  onClickMenuItem(MenuButtonClickEventName.DISTRIBUTION)
                }
              >
                <MenuTag variant="stage" stageRestriction={4} />
                <DistroIcon
                  width={32}
                  height={32}
                  style={{ marginBottom: "4px", marginTop: "4px" }}
                />
                <span className="label">
                  {t("components.MenuLateral.distro")}
                </span>
              </NavLink>
            )}

            <NavLink
              to="/pitching"
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.PITCHING)}
            >
              <MenuTag variant="stage" stageRestriction={4} />
              <PitchinIcon className="icon" />
              <span className="label">
                {t("components.MenuLateral.pitching")}
              </span>
            </NavLink>
            <NavLink
              to={acessoReleasePlanning ? "/releases-schedules" : "#"}
              className="menu-grid-item body-regular"
              onClick={() =>
                acessoReleasePlanning &&
                onClickMenuItem(MenuButtonClickEventName.RELEASES)
              }
            >
              <MenuTag variant="stage" stageRestriction={4} />
              <ReleasesScheduleIcon className="icon" />
              <span className="label">
                {t("components.MenuLateral.releasesSchedule")}
              </span>
            </NavLink>
            <NavLink
              to="#"
              className="menu-grid-item body-regular"
              role="button"
              style={{ display: "none" }}
            >
              <MenuTag variant="soon" />
              <AIAgentsIcon className="icon" />
              <span className="label">
                {t("components.MenuLateral.aiAgents")}
              </span>
            </NavLink>
          </div>
        </div>
        <div className="full-menu-section">
          <div className="section-title body-small">
            {t("components.MenuLateral.labelServices")}
          </div>
          <div
            className="menu-grid"
            onMouseMove={handleShineMove}
            onMouseLeave={handleShineLeave}
          >
            <a
              href={allowLabelServices ? LabelServicesCalendlyLink : "#"}
              className="menu-grid-item body-regular"
              role="button"
              target={allowLabelServices ? "_blank" : undefined}
              rel={allowLabelServices ? "noopener noreferrer" : undefined}
              onMouseDown={(e) => e.preventDefault()}
            >
              <MenuTag variant="stage" stageRestriction={7} />
              <HumanTeamIcon className="icon" />

              <span className="label" style={{ fontSize: 12 }}>
                {t("components.MenuLateral.humanTeam")}
              </span>
            </a>
          </div>
        </div>
        {fullScreen && (
          <button
            className="close-btn full-menu-close"
            onClick={() => onClickMenuItem(MenuButtonClickEventName.OPEN_MENU)}
          >
            <IconMenu fill="#bcb8f7" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ContentMenu;
